import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { findKeyBaseOnValue, formatTypeAheadOptionsWithFullDescription } from '../../ModificationsUtils';

export const PlanField = () => {
  const { control, getValues, setValue } = useFormContext();
  const { t } = useTranslation();
  const isModEdit = useSelector(selectIsEditMod);
  const ptoPlanDescription = 'ptoPlanDescription';
  const [ptoOptions, setPtoOptions] = useState([]);
  const isUndoModal = useSelector(selectIsUndoModal);

  const getPtoDropDown = async () => {
    const options = await getSearchFilterOptions('ptoPlan');
    const descriptionOptions = await getSearchFilterOptions('ptoPlanDescription');

    if (options?.length > 0 && descriptionOptions?.length > 0) {
      const newOptions = formatTypeAheadOptionsWithFullDescription(options, descriptionOptions);
      setPtoOptions(orderBy(newOptions, 'id', 'asc'));
    }
  };

  useEffect(() => {
    getPtoDropDown();
  }, [isUndoModal]);

  const onSelectionChange = value => {
    setValue(ptoPlanDescription, value);
    const selectedOption = findKeyBaseOnValue(ptoOptions, value);
    setValue('ptoPlanFullDescription', selectedOption.FullDescription);
  };

  return (
    <Controller
      control={control}
      name={ptoPlanDescription}
      render={({ field: { onChange, ...rest } }) => (
        <FormInputDropdown
          useMenuItem={true}
          name={ptoPlanDescription}
          label={t('placement.placementMods.ptoPlan')}
          require={true}
          standard={true}
          options={ptoOptions ?? []}
          handleChange={e => {
            onSelectionChange(e.target.value);
            onChange(e.target.value);
          }}
          inputValue={getValues(ptoPlanDescription) ?? ''}
          readOnly={!isModEdit}
        ></FormInputDropdown>
      )}
    />
  );
};
